export default __webpack_public_path__ + "static/media/cashbackisEmpty.1bb1f224.svg";